import { WiseOwlBlock } from "@twiliointernal/org/twilio/e2-commons/shared/definitions";

import { ChatMessageData } from "../../../components";
import { EmptyStateVariant } from "../../../components/emptyState/definitions/types";
import { CustomerFeedbackFormValues } from "../../../components/feedback/definitions/types";
import { PreChatHeaderProps } from "../../../components/preChatHeader/definitions/types";

export interface WiseOwlChatProps {
  chatHistory: ChatHistoryItem[];
  chatId?: string;
  // TODO: Potentially deprecate after API integration
  chatMessages?: ChatMessageData[];
  blocks: WiseOwlBlock[];
  // Helps with scroll/New message CTA rendering logic
  newAiMessageStatus?: NewAiMessageStatus;
  loadingConfiguration: WiseOwlLoadingConfiguration;
  preChatProps: PreChatProps;
  variantOptions?: NewChatVariantOptions;
  disabled?: boolean;
  onStartNewChat?: (payload: NewChatFormValues) => void;
  onSendChatMessage?: (payload: SendMessageFormValues) => void;
  onSubmitFeedback?: (payload: CustomerFeedbackFormValues) => void;
  handleRetry?: (payload: string) => void;
  styleConfiguration?: WiseOwlStyleConfiguration;
}

export interface WiseOwlLoadingConfiguration {
  fetchChatById: boolean;
  preChat: boolean;
  submission: boolean;
}

export interface WiseOwlStyleConfiguration {
  chatContainerHeight?: string;
}

export interface PreChatProps extends PreChatHeaderProps {
  blocks: WiseOwlBlock[];
  loading: boolean;
}

export interface NewChatFormValues {
  input: string;
}

export enum ChatFormLabels {
  // technically not a form field. relevant for WOBK implementation
  chatId = "chatId",
  input = "input",
}

export interface NewChatVariantOptions {
  variant: EmptyStateVariant.oops;
  // EmptyState will provide an ability to redirect from the unusable view.
  ctaText: string;
  ctaUrl: string;
}

export interface SendMessageFormValues {
  chatId?: string;
  input: string;
}

export enum NewAiMessageStatus {
  None = "none",
  Loading = "loading",
  Complete = "complete",
}

// Used for displaying chat history. Essentially a partial of any Chat object
export interface ChatHistoryItem {
  id: number;
  title: string;
  [key: string]: any;
}

export interface ViewChatHistoryProps {
  chatHistory: ChatHistoryItem[];
  onClickChatHistoryItem: (id: number) => void;
  onViewAllChatHistory: () => void;
}
